import * as React from 'react';
import { observer } from 'mobx-react';
import { Layout } from '@iba-team/portal-react-components/dist';
import { useEffect } from 'react';
import { RoleItem } from './RoleItem';
import { Acting } from '../../store/Acting';
import './ActingRole.scss';
import { useTranslation } from 'react-i18next';
import { useUsageStatistics } from '../../utils/hooks';
import apiConfig from '../../api/routes';

export const ActingPerson = observer(() => {
  const {getActingRoles ,actingRoles} = Acting;
  const {t} = useTranslation();
  useUsageStatistics(apiConfig.statisticsUsageService.actingPersonPage);

  useEffect(() => {
    getActingRoles();
  },[]);

  return(
    <Layout className={'acting_person'} header={{layoutName: t('acting_roles.title')}}>
      <div className={'acting_person__description'}>{t('acting_roles.description')}
        <a target='_blank' href={'https://confluence.ibagroup.eu/display/LMS/Acting+person+in+Leave+Management'} rel="noreferrer">More...</a></div>
      <div className={'acting_person__actings'}>
        {actingRoles.map(r =>
          <RoleItem role={r}/>
        )}
      </div>

    </Layout>
  );
});
